import React from 'react';
import './NoAvailableTherapist.scss';
import { Typography } from "src/latest/src/components";


type NoAvailableTherapistProps = {
  noAvailIcon: string;
  noAvailText: string;
};

const NoAvailableTherapist: React.FC<NoAvailableTherapistProps> = ({
  noAvailIcon,
  noAvailText,
}) => {
  return (
    <>
      <div className={`no-available-therapist-card text-center  bg-white`}>
        <div className="no-available-therapist-img-border">
          <div className="no-available-therapist-img-container">
            <img src={noAvailIcon} className="no-available-therapist-img" alt='Icon' />
          </div>
        </div>
        <Typography className="no-available-therapist-text">
          {noAvailText}
        </Typography>
      </div>
    </>
  );
};

export default NoAvailableTherapist;
